import { ApiResourceBaseClass as a } from "./baseApiCalls.js";
const t = "booking-links/generic", e = "business";
class k extends a {
  /**
   * Retrieves the generic booking link for a given business.
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/business/{businessId}/booking-links/generic`
   *
   * @param {string} businessId - The ID of the business.
   * @returns {Promise<string>} A promise that resolves to the booking link URL.
   */
  getGenericBookingLink = async (n) => {
    const { data: s } = await this.get(
      `${e}/${n}/${t}`
    );
    return s.url;
  };
  /**
   * Updates the generic booking link for a given business.
   *
   * HTTP Verb: `POST`
   * Endpoint URL: `/business/{businessId}/booking-links/generic`
   *
   * @param {string} businessId - The ID of the business.
   * @param {GenericBookingLinkUpdateParams} queryParams - The new URL to set.
   * @returns {Promise<boolean>} A promise that resolves to the success status.
   */
  updateGenericBookingLink = async (n, s) => {
    const { url: i } = s, { data: o } = await this.post(
      `${e}/${n}/${t}`,
      { url: i }
    );
    return o;
  };
}
export {
  e as BUSINESS_RESOURCE_URI,
  k as BookingLink,
  t as RESOURCE_URI
};
